import React, { useState } from 'react'; 
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import Header from './component/header' 
import Home from './pages/home' 
import Gs from './theme/globalStyles';
import { ThemeProvider } from 'styled-components'
import { theme } from './theme/theme' 


function App() {   

  const [isDark,setDarkTheme] = useState(true);
  const selectedTheme = theme(isDark);

  function setTheme(flag){
    setDarkTheme(flag);    
  }

  return (
    <Router  > 
    <ThemeProvider theme={selectedTheme}>
      <section className='bodySection clearfix'>
        <Gs.GlobalStyle />  
          <Header isDarkTheme={isDark} setTheme={setTheme}  />  
            <Switch>
            <Route path="/" exact> <Home isDarkTheme={isDark}  />  </Route> 
            {/* <Route path="/page02" exact> <Page02 isDarkTheme={isDark}  />  </Route>  */}
            </Switch> 
          
        </section>
    </ThemeProvider>
    </Router> 
  );
}

export default App;